module.exports = __webpack_public_path__ + "img/profile-img.339e4ad7.svg";